






















































































































































































































import Vue from 'vue'
import { getScoreType } from '@/commons/score_mixin'
import DatasetStatus from './DatasetStatus.vue'
import DatasetResult from './DatasetResult.vue'
import DatabasesStatus from '@/components/DatabasesStatus/DatabasesStatus.vue'
import { databases } from '@/data-dummy/data-dummy'
import { DATASETS_STATUSES as statuses } from '@/config/constants'

export default Vue.extend({
  name: 'Dataset',
  components: {
    DatasetStatus,
    DatasetResult,
    DatabasesStatus
  },
  props: {
    details: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: '',
      required: true
    },
    sources: {
      type: String,
      default: null,
      required: true
    },
    status: {
      type: String,
      default: statuses.inProgress,
      required: true
    },
    progress: {
      type: Number,
      default: 0
    },
    score: {
      type: Number,
      default: null
    },
    explanations: {
      type: Array as () => Array<{
        icon: string,
        text: string,
      }>,
      default: () => ([])
    },
    showSources: {
      type: Function,
      default: () => ({})
    }
  },
  data: () => ({
    show: false,
    statuses,
    databases,
    showDatabasesStatuses: false
  }),
  methods: {
    toogleDatabasesStatuses () {
      this.showDatabasesStatuses = !this.showDatabasesStatuses
    },
    goToPageTop () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    toggleDataset () {
      this.show = !this.show

      if (this.show) {
        this.$gtag.event('dataset_expanded', {
          dataset: this.name,
          progress: this.progress
        })
      }
    }
  },
  computed: {
    scoreClass () {
      let selectors = getScoreType(this.score)
      selectors += this.score === null ? 'skeleton-box' : ''
      return selectors
    }
  }
})
